import { auth, firestore, functions } from "../Firebase";
import {
  setRole,
  showSnackbarAction,
  updateUserStatus,
  setUser,
  clearUser,
  setOrganization,
  setOrganizationId,
  setFirstLogin,
  setPaymentStatus,
  setOrganizationData,
  setAuthToken
} from "../Redux/actions";
import { emailValidate, passwordValidate } from "../Values/validatorsnew";
import { url} from "../Values/constants";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import axiosHandler from "./axiosHandler";
import MMBRoute from "../Routes/mmBRoute"

// const updateWebDeviceId = (uid: any, value: any) => {
//   let docRef = firestore.collection("users").doc(uid);
//   docRef.update({
//     web_device_id: value
//   })
//     .then(() => {
//       console.log("Document successfully updated!");
//     })
//     .catch((error) => {
//       console.error("Error updating document: ", error);
//     });
// }
function generateSessionToken() {
  return uuidv4();
}



const monitorSession= (userId:any, sessionToken:any,setOpenLogoutModal: any)=> {
  const userDocRef = firestore.collection('users').doc(userId);

  userDocRef.onSnapshot((doc) => {
    const userData:any= doc.data();
    if (userData.sessionToken !== sessionToken) {
      // Invalidate current session
      setOpenLogoutModal(true);
      // alert('You have been signed out because your account was accessed from another device.');
      // signOut();
     
    }
  });

}

const getDeviceInfo = () => {
  try {
    // Retrieve data from localStorage
    const device_id = localStorage.getItem('device_id') || "Unknown Device ID";
    const device_ip = localStorage.getItem('device_ip') || "Unknown IP";
    const device_name = localStorage.getItem('device_name') || navigator.userAgent;

    // Return the collected information
    return {
      device_id,
      device_name,
      device_ip
    };
  } catch (error) {
    console.error("Error retrieving device info:", error);
    return {
      device_id: "Unknown Device ID",
      device_name: "Unknown Device Name",
      device_ip: "Unknown IP",
    };
  }
};


export const handleUser = async (uid: any, user: any, dispatcher: any, setOpenLogoutModal: any) => {
  // const webDeviceId = localStorage.getItem("web_device_id");
  // firestore
  //   .collection('users')
  //   .doc(uid).get().then((data) => {
  //     if (data === null) {
  //       return;
  //     }
  //     const userData = data.data();
  //     if (userData) {
  //       if (userData.web_device_id) {
  //         if (userData.web_device_id === webDeviceId) {
  //           console.log("User Login Validated")
  //         } else {
  //           setOpenLogoutModal(true);
  //         }
  //       }
  //       else {
  //         let newWebDeviceId = uuidv4();
  //         updateWebDeviceId(uid, newWebDeviceId);
  //         localStorage.setItem("web_device_id", newWebDeviceId);
  //       }
  //     }
  //   })
 

  const sessionToken = generateSessionToken();

      //  console.log("session token",sessionToken)

        const userDocRef = firestore.collection('users').doc(uid);
        await userDocRef.set({
          sessionToken: sessionToken,
          isLoggedIn: true
        }, { merge: true });

        const doc = await userDocRef.get();
        if (doc.exists) {
          // console.log('Document data:', doc.data());
        } else {
          // console.error('No such document!');
        }

        localStorage.setItem('sessionToken', sessionToken);

        // Monitor session changes
        monitorSession(uid, sessionToken,setOpenLogoutModal);
};




export const handlePaymentStatus = (organizationId: any,user: any,dispatcher: any) => {
  const subscriber = firestore
    .collection('organizations')
    .doc(organizationId)
    .onSnapshot((data) => {
      if (data === null) {
        return;
      }
      const orgData = data.data();
      if (orgData) {
        if (orgData.payment_status === false) {
          // if(user.profile !== "Lead Manager"){
          dispatcher(showSnackbarAction("Your readpro subscription has expired, Please contact your admin", "error"));
          dispatcher(setPaymentStatus({ paymentStatus: false }));
          auth.signOut();
          // }
          // else{
          //   dispatcher(setPaymentStatus({paymentStatus:false}));
          // }
        } else {
          dispatcher(setPaymentStatus({ paymentStatus: true }));
        }
      }
    });
  return subscriber;
};

export const handlePaymentStatus1 =async (organizationId: any, user: any, dispatcher: any) => {
  // const intervalId = setInterval(async () => {
    try {
      const response = await axiosHandler.get(
        url + "/organizations/fetchSingleOrganization",
        {
          params: {
            organization_id:organizationId
          },
        }
      );;
      const orgData = response?.data?.data;

      if (new Date(orgData.valid_till) <= new Date()) {
        // if(user.profile!== "Lead Manager"){
        // dispatcher(showSnackbarAction("Your readpro subscription has expired, Please contact your admin", "error"));
        dispatcher(setPaymentStatus({ paymentStatus: false }));
        handleLogout();
        dispatcher(showSnackbarAction("Your readpro subscription has expired, Please contact your admin", "error"));
        // window.location.reload()
        // }
        // else{
        //   dispatcher(setPaymentStatus({paymentStatus:false}));
        // }
      } else {
        dispatcher(setPaymentStatus({ paymentStatus: true }));
      }
    } catch (error) {
      // console.log("Error:", error);
    }
  // }, 1000); // poll every 1 second

  // return () => clearInterval(intervalId);
};


export const checkUser = (dispatcher: any) => {
  auth.onAuthStateChanged(function (user) {
    
    if (user) {
      user.getIdTokenResult().then((result) => {
        if (
          result.claims.firstLogin === true ||
          result.claims.firstLogin === undefined
        ) {
          dispatcher(updateUserStatus(false));
          dispatcher(setFirstLogin(true));
        } else {
          if (result.claims.role) {
            if (result.claims.role === "superAdmin") {
              dispatcher(
                setUser({
                  user_first_name: "SuperAdmin",
                  user_last_name: "",
                  user_email: user.email,
                })
              );
            }
            if (result.claims.role === "organization") {
              if (user.email) {
                fetchOrganizationData(user.email, dispatcher,user.uid);
              }
            } else if (result.claims.role !== "superAdmin") {
              fetchUserData(user.uid, dispatcher);
            }

            dispatcher(setRole(result.claims.role));
            dispatcher(updateUserStatus(true));
            dispatcher(setFirstLogin(false));
          } else {
            dispatcher(setRole("unauthorized"));
            auth.signOut();
            dispatcher(showSnackbarAction("Unauthorized User !!", "error"));
          }
        }
      });
    } else {
      dispatcher(setFirstLogin(false));
      dispatcher(clearUser());
      dispatcher(updateUserStatus(false));
    }
  });
};

export const fetchOrganizationData = async (email: string, dispatcher: any,uid:any) => {
  firestore
    .collection("organizations")
    .where("admin_email_id", "==", email)
    .get()
    .then((organization) => {
      if (organization) {
        const data = organization.docs[0].data();
        dispatcher(setOrganizationData({organizationData:{}}));
        if (data.status === "ACTIVE") {
          dispatcher(setOrganization(data));
          dispatcher(setOrganizationData({organizationData:data}));
          dispatcher(setOrganizationId(organization.docs[0].id));
          dispatcher(
            setUser({
              user_first_name: data.admin_first_name,
              user_last_name: data.admin_last_name,
              user_email: data.admin_email_id,
              uid:uid,
              organization_id:organization.docs[0].id
            })
          );
        } else {
          dispatcher(
            showSnackbarAction("User is INACTIVE! Contact Admin!!", "error")
          );
          auth.signOut();
        }
      } else {
        // console.log("org not found");
      }
    })
    .catch((err) => {}
      // console.log("fetch organization error", err)
  );
};

export const fetchUserData = (uid: string, dispatcher: any) => {
  firestore
    .collection("users")
    .doc(uid)
    .onSnapshot((user) => {
      if (user) {
        let data: any = user.data();
        // console.log("user.orggggggggggggggggggggggggggggg",data)
        if (data.status === "ACTIVE") {
          firestore
            .collection("organizations")
            .doc(data.organization_id)
            .onSnapshot((org)=>{
              let orgData: any = org.data();
              if (data.profile!=="Sales" && data.profile!=="Team Lead")
              {
                const userData = {
                  ...data,
                  current_active_status: orgData?.current_active_status,
                  is_approval_enabled: orgData?.is_approval_enabled,
                  is_shift_activation_enable: orgData?.is_shift_activation_enable
                };
               dispatcher(setUser(userData));
              }
              else if (orgData?.current_active_status === true) {
                const userData = {
                  ...data,
                  current_active_status: orgData?.current_active_status,
                  is_approval_enabled: orgData?.is_approval_enabled,
                  is_shift_activation_enable: orgData?.is_shift_activation_enable
                };
                dispatcher(setUser(userData));
              } else {
                auth.signOut();
                dispatcher(
                  showSnackbarAction("Organization is currently INACTIVE! Please Contact Your Admin!!", "error")
                );
              }
            })
          // dispatcher(setUser(user.data()));
        } else {
          auth.signOut();
          dispatcher(
            showSnackbarAction("User is INACTIVE! Contact Admin!!", "error")
          );
        }
      } else {
        // console.log("user not found");
      }
    })
    // .catch(() => console.log("fetch user error"));
};



export const signInFirebase = async (
  email: string,
  password: string,
  history: any,
  dispatcher: any,
  setLoad: (value: boolean) => void,
  setUserProfileUid:any
) => {
  let check = emailValidate(email);
  if (check.length === 0) {
    check = passwordValidate(password);
  }

  // console.log("admin login",password,email)

  if (check.length === 0) {
    setLoad(true);
    try {
      if (email && password) {
       const useData= await auth.signInWithEmailAndPassword(email, password);
       setUserProfileUid(useData?.user?.uid)
        setLoad(false);
      }
    } catch (error: any) {
      let errorMsg = "Error! Try Again";
      // console.log("error",error)
      if (error.message) {
        try {
          const errorJson = JSON.parse(error.message);
          if (errorJson.error && errorJson.error.message === "INVALID_LOGIN_CREDENTIALS") {
            errorMsg = "Error! Please Check Login Credentials";
          }
        } catch (jsonError) {
          // If error.message is not JSON, proceed with string checks
          if (error.message.includes("Access to this account has been temporarily disabled due to many failed login attempts.")) {
            errorMsg = "Error! Too Many Attempts";
          }
        }
      }

      dispatcher(showSnackbarAction(errorMsg, "error"));
      setLoad(false);
    }
  } else {
    dispatcher(showSnackbarAction(check, "error"));
    setLoad(false);
  }
};

export const resetPassword = async (
  password: string,
  confirmPassword: string,
  dispatcher: any,
  oobCode: any,
  setLoad: (value: boolean) => void,
  setReset: (value: boolean) => void,
  firstLogin: boolean,
  history: any
) => {
  if (password === "" || confirmPassword === "") {
    dispatcher(showSnackbarAction("Please Enter Password", "error"));
  } else if (password !== confirmPassword) {
    dispatcher(showSnackbarAction("Password does not match", "error"));
  } else {
    if (oobCode) {
      try {
        setLoad(true);
        await auth.confirmPasswordReset(oobCode, confirmPassword);
        setLoad(false);
        setReset(true);
      } catch (e) {
        // console.log("error:", e);
        setLoad(false);
      }
    } else if (firstLogin === true) {
      setLoad(true);
      const user = auth.currentUser;
      user
        ?.updatePassword(password)
        .then(() => {
          functions
            .httpsCallable("setFirstLogin")()
            .then(() => {
              dispatcher(showSnackbarAction("Password Updated !!", "success"));
              auth.signOut().then(() => {
                setLoad(false);
                history.push("/");
              });
            });
        })
        .catch((error) => {
          setLoad(false);
          // console.log("password reset error", error);
          auth.signOut();
          dispatcher(
            showSnackbarAction("Login Again to Reset Password!!", "error")
          );

          history.push("/");
        });
    }
  }
};

export const updatePassword = async (
  // oldPassword:string,
  organizationId: string,
  newPassword: string,
  userEmail:string,
  dispatcher: any,
  // oobCode: any,
  setLoad: (value: boolean) => void,
  // setReset: (value: boolean) => void,
  // firstLogin: boolean,
  history: any,
  authToken:any,
) => {
  try{
    const bodyData = {
      // old_password:oldPassword,
      organization_id: organizationId,
      new_password:newPassword,
      user_email:userEmail,
  }
  // axios.defaults.headers.common['x-access-token'] =
  //         authToken
    const res = await axiosHandler.post('users/updateUserPassword', bodyData);
    setLoad(false);
    history.push("/");
    dispatcher(
      showSnackbarAction("Password Updated", "success")
    );
  }catch (error) {
    setLoad(false);
    dispatcher(
      showSnackbarAction("Wrong Password", "error")
    );
  }
  
};

// export const handleLogout = () => {
//   // localStorage.removeItem('token');
//   localStorage.removeItem('user');  
//   window.location.href = '/';
// };

export const handleLogout = () => {
  setTimeout(() => {
    localStorage.removeItem('user');
    window.location.href = '/';
  }, 1000); // Delay of 2000 milliseconds (2 seconds)
  signOut();
};


export const fetchOrganizationDataMongo = async (user: any, dispatcher: any) => {
  try{
    let bodyData = {
      organization_id: user.organization_id
    }
    const res = await axiosHandler.get('/organizations/fetchSingleOrganization', { params: bodyData });
    let organization: any = res.data.data;
    if (organization) {
      dispatcher(setOrganizationData({organizationData:{}}));
      if (organization.status === "ACTIVE") {
        dispatcher(setOrganization(organization));
        dispatcher(setOrganizationData({organizationData:organization}));
        dispatcher(setOrganizationId(organization.organization_id));
        dispatcher(
          setUser({
            ...user,
            current_active_status: organization?.current_active_status,
            is_approval_enabled: organization?.is_approval_enabled,
            is_shift_activation_enable: organization?.is_shift_activation_enable,
            user_first_name: organization.admin_first_name,
            user_last_name: organization.admin_last_name,
            user_email: organization.admin_email_id,
            uid:user.uid,
            organization_id:organization.organization_id,
            profile: user.profile
          })
        );
      } else {
        dispatcher(
          showSnackbarAction("User is INACTIVE! Contact Admin!!", "error")
        );
        // auth.signOut();
        handleLogout();
      }
    } else {
      // console.log("org not found");
    }
  }catch(error){
    // console.log("error fetching organization",error);
  }
};


export const fetchUserDataMongo = async (user: any, dispatcher: any) => {
  try {
    if (user.status === "ACTIVE") {
      let bodyData = {
        organization_id: user.organization_id
      }
      const res = await axiosHandler.get('/organizations/fetchSingleOrganization', { params: bodyData });
      let organization: any = res.data.data;
      if (user.profile!=="Sales" && user.profile!=="Team Lead")
      {
        // alert("kol")
        const userData = {
          ...user,
          current_active_status: organization?.current_active_status,
          is_approval_enabled: organization?.is_approval_enabled,
          is_shift_activation_enable: organization?.is_shift_activation_enable
        };
       dispatcher(setUser(userData));
      }
      else if (organization?.current_active_status === true) {
        const userData = {
          ...user,
          current_active_status: organization?.current_active_status,
          is_approval_enabled: organization?.is_approval_enabled,
          is_shift_activation_enable: organization?.is_shift_activation_enable
        };
        dispatcher(setUser(userData));
      } else {
        // auth.signOut();
        dispatcher(
          showSnackbarAction("Organization is currently Inactive! Please Contact Your Admin!!", "error")
        );
        handleLogout();
      }
      dispatcher(setUser(user));
    } else {
      dispatcher(
        showSnackbarAction("User is Inactive! Contact Admin!!", "error")
      );
      handleLogout();
    }
  } catch (error: any) {
    // console.log("error: User not found",error);
  }
};

export const signInMongo = async (
  email: string,
  password: string,
  history: any,
  dispatcher: any,
  setLoad: (value: boolean) => void,
  setUserProfileUid:any,
  answer:any,
  captchaInput:any,
  setCaptcha:(value: any) => void,
  imageUrl: (value: any) => void,
  setAnswer:(value: any) => void,
) => {
  let check = emailValidate(email);
   if (check.length === 0) {
    check = passwordValidate(password);
  }
// console.log("check.length",check.length)
  if (check.length>0){
    dispatcher(showSnackbarAction(check, "error"));
    // setLoad(false);
    setCaptcha("")
    createCaptchaV2(
      (value)=>{imageUrl(value)},
          (value)=>{setAnswer(value)},
          dispatcher
    );
  return;
  }else
  if(captchaInput.length===0){
    dispatcher(
        showSnackbarAction(
          'Please enter captcha',
          'error'
        )
      );
    return;
  }else {
    setLoad(true);
    try {
      const deviceInfo = getDeviceInfo();
      const bodyData = {
        user_email: email,
        password: password,
        device_type: "WEB",
        answer:answer,
        captchaInput:captchaInput,
        device_id: deviceInfo.device_id, 
        device_ip: deviceInfo.device_ip, 
        device_name: deviceInfo.device_name
    }
      const res = await axiosHandler.post('/auth/v3/signIn', bodyData);
      let user = res.data.data.user;
      const { token } = user;
      localStorage.setItem('user', JSON.stringify(user));
      dispatcher(setAuthToken({authToken: token}))
      setUserProfileUid(user.uid);
      if (
        user.first_login === true ||
        user.first_login === undefined
      ) {
        dispatcher(updateUserStatus(false));
        dispatcher(setFirstLogin(true));
        dispatcher(setRole(user.role));
        dispatcher(setUser({...user}));
      } else {
        if (user.role === "superAdmin") {
          dispatcher(
            setUser({
              user_first_name: "Super Admin",
              user_last_name: "",
              user_email: user.user_email,
            })
          );
        }
        if (user.role === "organization") {
          fetchOrganizationDataMongo(user, dispatcher);
        } else if (user.role !== "superAdmin") {
          fetchUserDataMongo(user, dispatcher);
        }

        dispatcher(setRole(user.role));
        dispatcher(updateUserStatus(true));
        dispatcher(setFirstLogin(false));
      }
      history.replace("/");
      setLoad(false);
    } catch (error: any) {
      let errorMsg = error?.response?.data?.message ? error.response.data.message : "Invalid login credentials";
      dispatcher(showSnackbarAction(errorMsg, "error"));
      setLoad(false);
      setCaptcha("")
      createCaptchaV2(
        (value)=>{imageUrl(value)},
            (value)=>{setAnswer(value)},
            dispatcher
      )
    }
  } 
};

export const signInMongoMB = async (
  email: string,
  password: string,
  history: any,
  dispatcher: any,
  setLoad: (value: boolean) => void,
  setUserProfileUid:any,
  answer:any,
  captchaInput:any,
  setCaptcha:(value: any) => void,
  imageUrl: (value: any) => void,
  setAnswer:(value: any) => void
) => {

  if(captchaInput.length===0){
    dispatcher(
        showSnackbarAction(
          'please enter captcha',
          'error'
        )
      );
    return;
}

  let check = emailValidate(email);
  if (check.length === 0) {
    check = passwordValidate(password);
  }

  if (check.length === 0) {
    setLoad(true);
    try {
      const deviceInfo = getDeviceInfo();
      const bodyData = {
        email: email,
        password: password,
        device_type: "WEB",
        answer:answer,
        captchaInput:captchaInput,
        device_id: deviceInfo.device_id, 
        device_ip: deviceInfo.device_ip, 
        device_name: deviceInfo.device_name
    }
      const res = await axiosHandler.post('/auth/v2/emailPassSignInMB', bodyData);
      let user = res.data.data.user;
      const { token } = user;
      localStorage.setItem('user', JSON.stringify(user));
      dispatcher(setAuthToken({authToken: token}))
      setUserProfileUid(user.uid);
      if (
        user.first_login === true ||
        user.first_login === undefined
      ) {
        dispatcher(updateUserStatus(false));
        dispatcher(setFirstLogin(true));
        dispatcher(setRole(user.role));
        dispatcher(setUser({...user}));
      } else {
        if (user.role === "superAdmin") {
          dispatcher(
            setUser({
              user_first_name: "Super Admin",
              user_last_name: "",
              user_email: user.user_email,
            })
          );
        }
        if (user.role === "organization") {
          fetchOrganizationDataMongo(user, dispatcher);
        } else if (user.role !== "superAdmin") {
          fetchUserDataMongo(user, dispatcher);
        }

        dispatcher(setRole(user.role));
        dispatcher(updateUserStatus(true));
        dispatcher(setFirstLogin(false));
      }
      history.replace("/");
      setLoad(false);
    } catch (error: any) {
      let errorMsg = error?.response?.data?.message ? error.response.data.message : "Invalid login credentials";
      dispatcher(showSnackbarAction(errorMsg, "error"));
      setLoad(false);
      setCaptcha("")
      createCaptchaV2(
        (value)=>{imageUrl(value)},
            (value)=>{setAnswer(value)},
            dispatcher
      )
    }
  } else {
    dispatcher(showSnackbarAction(check, "error"));
    setLoad(false);
    setCaptcha("")
    createCaptchaV2(
      (value)=>{imageUrl(value)},
          (value)=>{setAnswer(value)},
          dispatcher
    )
  }
};

// export const checkUserMongo = (dispatcher: any,user:any) => {
//   if (user?.profile) {
//     dispatcher(setAuthToken({authToken: user.token}));
//     if (
//       user.first_login === true
//     ) {
//       dispatcher(updateUserStatus(false));
//       dispatcher(setFirstLogin(true));
//     } else {
//       if (user.role === "superAdmin") {
//         dispatcher(
//           setUser({
//             user_first_name: "SuperAdmin",
//             user_last_name: "",
//             user_email: user.email,
//           })
//         );
//       }
//       if (user.role === "organization") {
//         fetchOrganizationDataMongo(user, dispatcher);
//         // if (user.email) {
//         //   fetchOrganizationDataMongo(user, dispatcher);
//         // }
//       } else if (user.role !== "superAdmin") {
//         fetchUserDataMongo(user, dispatcher);
//       }
      
//       dispatcher(setRole(user.role));
//       dispatcher(updateUserStatus(true));
//       dispatcher(setFirstLogin(false));
//     }
//   } else {
//     dispatcher(setFirstLogin(false));
//     dispatcher(clearUser());
//     dispatcher(updateUserStatus(false));
//   }
// };

// After OTP Login Changes
export const checkUserMongo = (dispatcher: any,user:any) => {
  if (user?.profile) {
    dispatcher(setAuthToken({authToken: user.token}));
    
      if (user.role === "superAdmin") {
        dispatcher(
          setUser({
            user_first_name: "SuperAdmin",
            user_last_name: "",
            user_email: user.email,
          })
        );
      }
      if (user.role === "organization") {
        fetchOrganizationDataMongo(user, dispatcher);
        // if (user.email) {
        //   fetchOrganizationDataMongo(user, dispatcher);
        // }
      } else if (user.role !== "superAdmin") {
        fetchUserDataMongo(user, dispatcher);
      }
      
      dispatcher(setRole(user.role));
      dispatcher(updateUserStatus(true));
      // dispatcher(setFirstLogin(false));
    
  } else {
    // dispatcher(setFirstLogin(false));
    dispatcher(clearUser());
    dispatcher(updateUserStatus(false));
  }
};

export const resetPasswordMongo = async (
  password: string,
  confirmPassword: string,
  dispatcher: any,
  oobCode: any,
  ts: any,
  setLoad: (value: boolean) => void,
  setReset: (value: boolean) => void,
  firstLogin: boolean,
  history: any,
  user: any,
  setRefershCaptcha:(value: boolean) => void,
  answer?:any,
  captchaInput?:any,
) => {
  if (password === "" || confirmPassword === "") {
    dispatcher(showSnackbarAction("Please Enter Password", "error"));
  } else if (password !== confirmPassword) {
    dispatcher(showSnackbarAction("Password does not match", "error"));
  } 
  else if (password.length < 8 || confirmPassword.length < 8) {
    dispatcher(showSnackbarAction("Minimum 8 char password required", "error"));
  }
  else {
    if (oobCode) {
      // try {
      //   setLoad(true);
      //   await auth.confirmPasswordReset(oobCode, confirmPassword);
      //   setLoad(false);
      //   setReset(true);
      // } catch (e) {
      //   console.log("error:", e);
      //   setLoad(false);
      // }
      try {
        setLoad(true);
        const bodyData = {
          password: confirmPassword,
          user_email: oobCode,
          ts:ts,
          captchaAnswer:answer,
          captchaInput:captchaInput,
        }
        const res = await axiosHandler.post('/auth/v3/resetPasswordForForgot', bodyData);
        dispatcher(showSnackbarAction("Password Updated !!", "success"));
        setLoad(false);
        // handleLogout();
        setReset(true);

      } catch (error:any) {
        dispatcher(showSnackbarAction(error?.response?.data?.message?error?.response?.data?.message:"Ann error occured, Please try again", "error"));
        // console.log("error:", e);
        setLoad(false);
        setRefershCaptcha(true)
      }
    } else if (firstLogin === true) {
      try {
        setLoad(true);
        const bodyData = {
          // organization_id: user.organization_id,
          password: confirmPassword,
          user_email: user.encryptEmail,
          captchaAnswer:answer,
          captchaInput:captchaInput,
          // user_email: user.user_email
        }
        const res = await axiosHandler.post('/users/v3/resetPasswordForFirstSignIn', bodyData);
        dispatcher(showSnackbarAction("Password Updated !!", "success"));
        setLoad(false);
        handleLogoutEmailLogin();

      } catch (error:any) {
        setLoad(false);
        // console.log("password reset error", error);
        setRefershCaptcha(true)
        dispatcher(
          showSnackbarAction(error?.response?.data?.message ? error.response.data.message:"Login Again to Reset Password!!", "error")
        );
        // handleLogoutEmailLogin();
      }
    }
  }
};


////////////////////otp based login /////////////////////////////

export const generateOtpV2 = async (
  mobileNumber: string,
  history: any,
  dispatcher: any,
  setShowErrorMessage: (value: any) => void,
  imageUrl: (value: any) => void,
  setAnswer:(value: any) => void,
  answer:any,
  captchaInput:any,
  userIp:any,
  setCaptcha:(value: any) => void
) => {
  try {
    const params = { contact_no: mobileNumber ,userIp:userIp,answer:answer,captchaInput:captchaInput};

    if(captchaInput.length===0){
      dispatcher(
          showSnackbarAction(
            'please enter captcha',
            'error'
          )
        );
      return;
  }

    const response = await axiosHandler.post('/auth/v2/generateOtp',  params);

    if (response.data?.success) {
      history.replace("/verifyOtp",{mobileNumber:mobileNumber,userId:response?.data?.userId,validity:response?.data?.validity,isd:response?.data?.isd,userIp:userIp});
      // console.log("go to verify screen",response.data)      
    } else {
      console.error("Failed to generate OTP:", response.data?.message || "Unknown error");
      setShowErrorMessage(response?.data?.message)
      // dispatcher(showSnackbarAction(response.data.message, "error"))
        // history.replace("/verifyOtp",{mobileNumber:mobileNumber});
        setCaptcha("")

        createCaptchaV2(
          (value)=>{imageUrl(value)},
              (value)=>{setAnswer(value)},
              dispatcher
        )
    }
  } catch (error) {
    console.error("Error during OTP generation:", error);
    setCaptcha("")

    dispatcher(showSnackbarAction("Error occured to generate otp", "error"))

    // history.replace("/verifyOtp",{mobileNumber:mobileNumber});
  }
};

export const resendOtp = async (
  mobileNumber: string,
  isd:any,
  userIp:any,
  history: any,
  dispatcher: any,
  setShowErrorMessage: (value: any) => void,
  
) => {
  try {
    const params = { contact_no: mobileNumber,userIp:userIp };

    const response = await axiosHandler.post('/auth/generateOtp',  params);

    if (response.data?.success) {
      history.replace("/verifyOtp",{mobileNumber:mobileNumber,userId:response?.data?.userId,validity:response?.data?.validity,isd:isd});
      // console.log("go to verify screen",response.data)      
    } else {
      console.error("Failed to generate OTP:", response.data?.message || "Unknown error");
      setShowErrorMessage(response?.data?.message)
      // dispatcher(showSnackbarAction(response.data.message, "error"))
        // history.replace("/verifyOtp",{mobileNumber:mobileNumber});
    }
  } catch (error) {
    console.error("Error during OTP generation:", error);

    dispatcher(showSnackbarAction("Error occured to generate otp", "error"))

    // history.replace("/verifyOtp",{mobileNumber:mobileNumber});
  }
};

export const signInOtpMongo = async (
  mobileNumber:any,
  otp:any,
  userId:any,
  isd:any,
  history: any,
  dispatcher: any,
  setLoad: (value: boolean) => void,
  setUserProfileUid:any,
  openmodal:(value: boolean) => void,
  setMmbUrl:(value: boolean) => void,
  setShowErrorMessage:(value: any) => void
) => {

    setLoad(true);
    try {
      const deviceInfo = getDeviceInfo();
      let data={
        contact_no:mobileNumber,
        otp:otp,
        device_type:"WEB",
        userId:userId,
        isd:isd || "50",
        device_id: deviceInfo.device_id, 
        device_ip: deviceInfo.device_ip, 
        device_name: deviceInfo.device_name
      }
     
      const res = await axiosHandler.post('/auth/verifyOtp',data);

      // console.log("rishabh arerfewrter",res.data)
      // setShowErrorMessage(res.data.message)
      if(res.data.success===false && res.data.message!=="User not found"){
          if(res.data.message==="OTP not available for mobile"){
            setShowErrorMessage("Invalid OTP")
            // dispatcher(showSnackbarAction("Invalid OTP", "error"))
            return;
          }
          setShowErrorMessage(res.data.message)
        // dispatcher(showSnackbarAction(res.data.message, "error"))
        return;
       }
      else if(res.data.success===false && res.data.message==="User not found"){
        // dispatcher(showSnackbarAction(res?.data?.message, "error"));
       
        // setMmbUrl(res.data?.data?.token)
        // // openmodal(true);
        // history.replace("/mmbPage",{url:res.data?.data?.token})
        // dispatcher(updateUserStatus(true));
        setShowErrorMessage(res.data.message)
       
        return;
      }
      
      let user = res.data.data.user;
      // console.log("user.....",user)
      const { token } = user;
      localStorage.setItem('user', JSON.stringify(user));
      dispatcher(setAuthToken({authToken: token}))
      setUserProfileUid(user.uid);
      
        if (user.role === "superAdmin") {
          dispatcher(
            setUser({
              user_first_name: "Super Admin",
              user_last_name: "",
              user_email: user.user_email,
            })
          );
        }
        if (user.role === "organization") {
          fetchOrganizationDataMongo(user, dispatcher);
        } else if (user.role !== "superAdmin") {
          fetchUserDataMongo(user, dispatcher);
        }

        dispatcher(setRole(user.role));
        dispatcher(updateUserStatus(true));
        history.replace("/")
        // dispatcher(setFirstLogin(false));
      
      setLoad(false);

      return res.data
    } catch (error: any) {
      let errorMsg = error?.response?.data?.message ? error.response.data.message : "Invalid login credentials";
      dispatcher(showSnackbarAction(errorMsg, "error"));
      setLoad(false);
    }
};

export const createCaptcha = async(
  imageUrl: (value: any) => void,
  setAnswer:(value: any) => void,
  dispatcher: any
)=>{
  try {
    const res = await axiosHandler.post('/auth/createCaptcha');
      
    if(res.data){
      imageUrl(res.data.image)
      setAnswer(res.data.answer)
    }
     
  } catch (error:any) {
    console.error("Error during OTP generation:", error.message);

    dispatcher(showSnackbarAction("Error occured while generating the captcha", "error"))

  }
}

export const createCaptchaV2 = async(
  imageUrl: (value: any) => void,
  setAnswer:(value: any) => void,
  dispatcher: any
)=>{
  try {
    const res = await axiosHandler.post('/auth/v2/createCaptcha');
      
    if(res.data){
      imageUrl(res.data.image)
      setAnswer(res.data.answer)
    }
     
  } catch (error:any) {
    console.error("Error during OTP generation:", error.message);

    dispatcher(showSnackbarAction("Error occured while generating the captcha", "error"))

  }
}

export const handleLogoutEmailLogin = () => {
  setTimeout(() => {
    localStorage.removeItem('user');
    // window.location.href = '/signInEmail';
    window.location.href = '/';
  }, 1000); // Delay of 2000 milliseconds (2 seconds)
  signOut();
};



export const signOut = async()=>{
  try {
    const res = await axiosHandler.get('/users/signOut');
      return
    
  } catch (error:any) {
    console.error("Error during OTP generation:", error.message);
     return

  }
}
